/**
 * Skill import route — hosts the 3-step `ImportStepper` and handles the
 * post-success redirect. The stepper itself owns the source/validate/confirm
 * UX; this route only provides the page chrome and the navigation handler.
 */

import { createFileRoute, Link, useNavigate } from "@tanstack/react-router";
import { ArrowLeft } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { ImportStepper } from "@/components/skills/import-stepper";

export const Route = createFileRoute("/_authenticated/skills/import")({
  component: SkillImportPage,
  head: () => ({ meta: [{ title: "Import skill — CSaaS" }] }),
});

function SkillImportPage() {
  const navigate = useNavigate();

  return (
    <div className="max-w-3xl space-y-6">
      <div>
        <Button variant="ghost" size="sm" asChild className="-ml-2 mb-3">
          <Link to="/skills">
            <ArrowLeft className="h-4 w-4" /> All skills
          </Link>
        </Button>
        <h1 className="font-display text-3xl font-semibold tracking-tight">Import a skill</h1>
        <p className="mt-1 max-w-2xl text-sm text-muted-foreground">
          Paste a SKILL.md, drop a full Anthropic-format bundle, then preflight it against the same
          validator the server runs on import.
        </p>
      </div>

      <ImportStepper
        onComplete={(result) => {
          toast.success("Skill imported", {
            description: `${result.name} · v${result.version}`,
          });
          navigate({ to: "/skills/$name", params: { name: result.name } });
        }}
      />
    </div>
  );
}
